import axios from "axios";
import { LOGIN_OTP_URL } from "../../configuration/Utils/constService";

export const logInOtp = (data) =>
  axios.post(LOGIN_OTP_URL, data, { withCredentials: true });
